import SEOLandingTemplate from './SEOLandingTemplate';

export default function SiteAuditPageSEO() {
  return (
    <SEOLandingTemplate
      title="Site Audit Tool"
      metaTitle="Free Site Audit Tool | Sungresh"
      metaDescription="Audit a live page for common technical SEO issues: missing meta tags, broken links, missing alt text, and more, with a health score."
      h1="Free Site Audit Tool"
      sub="A live crawler checks your page for common technical SEO issues — missing tags, broken links, missing alt text — and returns a health score with specific findings."
      keywords="site audit tool, free site audit tool, seo audit tool, technical seo audit"
      ctaLink="/audit/site"
      ctaText="Audit a Site Free"
      features={[
        { icon: '💯', title: 'Health Score', desc: 'An overall score based on the issues found' },
        { icon: '🔗', title: 'Broken Links', desc: 'Flags broken internal links and error pages' },
        { icon: '🖼️', title: 'Missing Alt Text', desc: 'Images without alt attributes' },
        { icon: '📝', title: 'Meta Tag Gaps', desc: 'Missing or duplicate titles, meta descriptions, and headings' },
      ]}
      faqs={[
        { q: 'Is this a real crawl or simulated data?', a: 'It performs a real, live HTTP fetch of your page and parses the actual HTML at the time you run the audit — not a cached or simulated result.' },
        { q: 'What should I prioritize fixing?', a: 'Fix outright errors first — broken links, missing titles, missing HTTPS — since these have the most direct impact. Then work through warnings like missing alt text or thin content.' },
        { q: 'How often should I re-audit a site?', a: 'Monthly, or right after significant changes to a page, is a reasonable cadence for most sites.' },
      ]}
    />
  );
}
